import React, {Component} from "react";
import TopLine from "./pages/Main/TopLine/TopLine";
import FavoriteFilter from "./components/FavoriteFilter";
import Events from "./pages/Main/Events/Events";

class RightSide extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const {isTopLive} = this.props;

		return (
			<div className="body__container__side-right">
				<TopLine/>
				<FavoriteFilter />
				<Events updateTime={5000} isTopLive={isTopLive}/>
			</div>
		);
	}
}

export default RightSide;


// WEBPACK FOOTER //
// ./src/app/RightSide.js